// extracted by mini-css-extract-plugin
export var attachmentContainer = "_sb-0";
export var fileList = "_sb-2";
export var removeFileButton = "_sb-1";